{
  "nav": {
    "theSpace": "Пространство",
    "schedule": "Календарь",
    "practices": "Практики",
    "masters": "Мастера",
    "community": "Сообщество",
    "fund": "Фонд",
    "chats": "Чаты",
    "myCalendar": "Мой Календарь",
    "feed": "Лента",
    "profile": "Профиль",
    "messages": "Сообщения",
    "notifications": "Уведомления",
    "discussion": "Обсуждение",
    "guestRoom": "Гость Live-сессии",
    "dashboard": "Личный кабинет",
    "studio": "Студия",
    "settings": "Настройки",
    "aboutPlatform": "О платформе",
    "favorites": "Избранное",
    "calendar": "Календарь"
  },
  "menu": {
    "appearance": "Тема оформления",
    "language": "Язык",
    "logout": "Выйти",
    "login": "Войти",
    "masterBadge": "МАСТЕР"
  },
  "pageTitle": {
    "download": "Скачать приложение",
    "default": "Agapella — знания, практики и живые встречи",
    "home": "Пространство",
    "news": "Новости",
    "newsArticle": "Материал",
    "landing": "Живые практики 24/7",
    "referralLanding": "Приглашение",
    "login": "Вход",
    "register": "Регистрация",
    "confirmEmail": "Подтверждение почты",
    "forgotPassword": "Восстановление пароля",
    "resetPassword": "Новый пароль",
    "dashboard": "Личный кабинет",
    "me": "Мой профиль",
    "masters": "Мастера",
    "masterDetail": "Профиль мастера",
    "masterSubscriptions": "Подписки",
    "programPurchase": "Покупка программы",
    "programPage": "Программа",
    "agapeCenter": "Центр Agapē",
    "lives": "Расписание",
    "eventsCalendar": "Календарь",
    "eventsAll": "Все события",
    "eventsFilters": "Фильтры",
    "eventDetail": "Событие",
    "createEvent": "Создание события",
    "eventParticipants": "Кто участвует",
    "schedule": "Расписание",
    "upcoming": "Ближайшие",
    "practices": "Практики",
    "practiceDetail": "Практика",
    "uploadPractice": "Загрузить практику",
    "myCollection": "Моя коллекция",
    "settings": "Настройки",
    "liveDetail": "Live-сессия",
    "liveBroadcast": "Live-сессия",
    "chats": "Чаты",
    "chatThread": "Чат",
    "community": "Сообщество",
    "publicUserProfile": "Профиль",
    "publicUserPost": "Пост",
    "gamificationShare": "Путь Света",
    "circleChat": "Круг",
    "about": "О нас",
    "aboutPlatform": "О платформе",
    "environment": "Окружение",
    "gamificationPreview": "QA-превью геймификации",
    "support": "Поддержка",
    "contact": "Контакты",
    "notificationSettings": "Уведомления",
    "securitySettings": "Безопасность",
    "blockedUsers": "Заблокированные",
    "myCalendar": "Мой календарь",
    "myLibrary": "Моя библиотека",
    "memoryFacts": "Что я о тебе помню",
    "fund": "Фонд Agápe",
    "finance": "Финансы",
    "financeDocuments": "Мои документы",
    "agapellaSubscription": "Подписка Agapēlla",
    "fundDistribution": "Ваше распределение",
    "howItWorks": "Как это работает",
    "fundTransparency": "Прозрачность фонда",
    "referralCredits": "Реферальные баллы",
    "fundOnboarding": "Знакомство с фондом Agápe",
    "masterWallet": "Кошелёк",
    "docs": "Документация",
    "legalDoc": "Правовой документ",
    "mission": "Миссия Agapella",
    "ethicsCode": "Этический кодекс Agapella",
    "custDev": "CustDev",
    "soundLibrary": "Библиотека звуков",
    "practiceRooms": "Live-сессии",
    "createLiveSession": "Новая Live-сессия",
    "liveSessionEntry": "Вход в Live-сессию",
    "liveRoomSession": "Live-сессия",
    "roomAnnouncement": "О Live-сессии",
    "agapePractice": "Практика Agapē",
    "eventThread": "Обсуждение",
    "feed": "Лента",
    "guestRoom": "Гость Live-сессии",
    "masterSales": "Продажи",
    "masterAnalytics": "Аналитика",
    "notifications": "Уведомления",
    "payoutDetails": "Реквизиты для выплат"
  },
  "feed": {
    "empty": "Лента пока пустая"
  },
  "favorites": {
    "filter": {
      "all": "Всё",
      "events": "События",
      "practices": "Практики",
      "masters": "Мастера",
      "myRooms": "Мои Live-сессии"
    },
    "empty": {
      "all": "В избранном пока пусто. Жми сердечко на любой карточке, чтобы добавить сюда.",
      "events": "Нет событий в избранном. Жми сердечко на карточке события.",
      "practices": "Нет практик в избранном. Жми сердечко на любой практике.",
      "masters": "Нет подписок. Подпишись на мастера, чтобы видеть его здесь.",
      "myRooms": "Записи твоих Live-сессий появятся здесь, когда первая практика закончится."
    },
    "unsave": "Удалить из избранного"
  },
  "masterEvents": {
    "heading": "События мастера",
    "filter": {
      "all": "Все",
      "livestream": "Live-сессии",
      "offline": "Офлайн",
      "livepractice": "Live-практики"
    },
    "empty": {
      "all": "Пока нет запланированных событий.",
      "livestream": "Нет предстоящих Live-сессий.",
      "offline": "Нет предстоящих офлайн-встреч.",
      "livepractice": "Нет открытых Live-сессий."
    }
  },
  "state": {
    "loading": "Загрузка…",
    "error": "Что-то пошло не так",
    "empty": "Пока пусто",
    "retry": "Попробовать снова"
  },
  "buttons": {
    "logIn": "Войти",
    "signIn": "Войти",
    "signUp": "Зарегистрироваться",
    "logOut": "Выйти",
    "joinPractice": "В ПРАКТИКУ",
    "joinLiveNow": "ПОДКЛЮЧИТЬСЯ",
    "classSchedule": "КАЛЕНДАРЬ",
    "viewAll": "ВСЕ",
    "retry": "ПОВТОРИТЬ",
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "save": "СОХРАНИТЬ",
    "back": "НАЗАД",
    "next": "ДАЛЕЕ",
    "finish": "ГОТОВО",
    "accept": "Принять",
    "decline": "Отклонить",
    "notNow": "Не сейчас",
    "explore": "Обзор",
    "sendMessage": "ОТПРАВИТЬ",
    "message": "СООБЩЕНИЕ",
    "sending": "ОТПРАВКА...",
    "hide": "Скрыть",
    "goBack": "НАЗАД",
    "tryAgain": "ПОВТОРИТЬ",
    "browseLibrary": "БИБЛИОТЕКА",
    "explorePractices": "ПРАКТИКИ",
    "exploreSchedule": "КАЛЕНДАРЬ",
    "create": "Создать",
    "createA11y": "Создать",
    "quickRoom": "Быстрая комната",
    "quickRoomShort": "Быстрая",
    "quickRoomA11y": "Создать быструю комнату",
    "liveSession": "Live-сессия",
    "liveSessionShort": "Live",
    "liveSessionA11y": "Создать Live-сессию",
    "myCalendarUpper": "МОЙ КАЛЕНДАРЬ",
    "linkCopied": "Ссылка скопирована",
    "done": "Готово",
    "showMore": "Ещё",
    "showLess": "Свернуть"
  },
  "theme": {
    "mode": "{{mode}} режим"
  },
  "footer": {
    "tagline1": "Мастера, Live-сессии, сообщества, события – 24/7",
    "tagline2": "Платформа для тех, кто выбирает быть человеком на практике",
    "platform": "Платформа",
    "company": "Компания",
    "legal": "Правовая информация",
    "about": "О нас",
    "contact": "Контакты",
    "careers": "Карьера",
    "termsOfUse": "Пользовательское соглашение",
    "privacyPolicy": "Политика конфиденциальности",
    "aiNotice": "Уведомление об ИИ",
    "cookieSettings": "Настройки cookie",
    "streamingAgreement": "Соглашение для практиков",
    "deleteAccount": "Удаление аккаунта",
    "mission": "Миссия",
    "ethicsCode": "Кодекс этики",
    "referral": "Реферальная программа",
    "copyright": "© 2026 Agapella. Все права защищены.",
    "legalEntity": "В России сервис предоставляет АО «Цифровая ИИ Трансформация» · ИНН 9729424798 · КПП 772901001 · ОГРН 1267700307841 · 119618, г. Москва, ул. Богданова, д. 10, к. 2, помещ. 2/3",
    "legalEntityIntl": "AGAPE.IO Limited · Room 1803, 18/F, Lucky Centre, No. 165–171 Wan Chai Road, Wan Chai, Hong Kong",
    "designedFor": "Создано для гармонии."
  },
  "cookies": {
    "title": "Cookie и счётчики",
    "description": "Cookie нужны, чтобы работали вход, ваши настройки и базовая статистика посещений. Остальные аналитические и маркетинговые счётчики подключаются только с вашего согласия, выбрать можно по категориям.",
    "policyLink": "Политика конфиденциальности, раздел 15",
    "acceptAll": "Принять",
    "necessaryOnly": "Оставить только необходимые",
    "decline": "Отказаться",
    "customize": "Настроить",
    "settingsTitle": "Настройки cookie",
    "settingsIntro": "Выберите, какие cookie и счётчики можно использовать. Изменить выбор можно в любой момент: ссылка «Настройки cookie» есть внизу страницы и в настройках профиля.",
    "alwaysOn": "Всегда включены",
    "necessary": {
      "title": "Необходимые",
      "description": "Вход в аккаунт, безопасность, сохранение сессии и базовая статистика посещений, по которой мы видим, как работает платформа."
    },
    "functional": {
      "title": "Функциональные",
      "description": "Ваши настройки на этом устройстве: тема, язык, громкость, скрытые подсказки. Третьим лицам не передаются."
    },
    "analytics": {
      "title": "Аналитические",
      "description": "Дополнительные сторонние счётчики посещаемости. По ним видно, какие страницы открывают и что стоит улучшить."
    },
    "marketing": {
      "title": "Маркетинговые",
      "description": "Счётчики рекламных сервисов. По ним оценивается, какая реклама приводит людей на платформу."
    },
    "providers": {
      "metrika": "Яндекс Метрика",
      "ga4": "Google Analytics",
      "vk": "пиксель VK"
    },
    "providersList": "Подключаются: {{list}}",
    "providersNone": "Сейчас счётчиков этой категории нет.",
    "reloadHint": "Отключённый счётчик перестанет работать после обновления страницы.",
    "save": "Сохранить выбор",
    "close": "Закрыть"
  },
  "authCta": {
    "onboarding": {
      "heading": "Сохраните свои настройки",
      "body": "Зарегистрируйтесь, чтобы сохранить настройки и получать персональные рекомендации."
    },
    "gatedAction": {
      "heading": "Доступ к функциям Agapella",
      "body": "Пожалуйста, войдите в систему или зарегистрируйтесь для продолжения."
    }
  },
  "time": {
    "now": "сейчас",
    "justNow": "только что",
    "minsAgo": "{{count}} мин назад",
    "hoursAgo": "{{count}} ч назад",
    "daysAgo": "{{count}} д назад",
    "min": "мин",
    "minutes": "мин",
    "hourShort": "ч"
  },
  "calendar": {
    "button": "КАЛЕНДАРЬ",
    "google": "Google Календарь",
    "downloadIcs": "Скачать .ics",
    "addToCal": "В календарь",
    "downloadFailed": "Не удалось скачать файл календаря. Попробуйте ещё.",
    "googleFailed": "Не удалось открыть Google Календарь. Попробуйте ещё."
  },
  "errors": {
    "title": "Ошибка",
    "generic": "Что-то пошло не так. Попробуйте ещё.",
    "failedToPost": "Не удалось создать публикацию",
    "notFound": "Не найдено"
  },
  "events": {
    "liveNow": "LIVE",
    "live": "ЭФИР",
    "upcoming": "СКОРО",
    "notifyMe": "НАПОМНИТЬ",
    "notified": "НАПОМНИМ",
    "registered": "ЗАРЕГИСТРИРОВАН",
    "register": "РЕГИСТРАЦИЯ",
    "subscribed": "ПОДПИСАН",
    "online": "Live-сессия",
    "onlineEvent": "Live-сессия",
    "locationTba": "Уточняется",
    "locationTbaFull": "Место уточняется",
    "spotsAvailable": "{{left}} / {{total}} мест",
    "unlimitedSpots": "Неограниченное количество мест",
    "percentFilled": "% заполнено",
    "aboutThisEvent": "О МЕРОПРИЯТИИ",
    "contact": "КОНТАКТЫ",
    "featured": "РЕКОМЕНДУЕМ"
  },
  "eventContact": {
    "title": "Связаться с организатором",
    "aboutPrefix": "О: {{title}}",
    "messageSent": "Сообщение отправлено.",
    "messageDelivered": "Ваше сообщение доставлено. Вам ответят в ближайшее время.",
    "nameLabel": "ВАШЕ ИМЯ",
    "namePlaceholder": "Введите имя",
    "emailLabel": "ЭЛ. ПОЧТА (НЕОБЯЗАТЕЛЬНО)",
    "emailPlaceholder": "your@email.com",
    "messageLabel": "СООБЩЕНИЕ",
    "messagePlaceholder": "Ваше сообщение...",
    "emailFallback": "Или напишите напрямую: {{email}}",
    "validationError": "Пожалуйста, заполните имя и сообщение",
    "sendFailed": "Не удалось отправить. Попробуйте ещё."
  },
  "chat": {
    "folder": {
      "ai": "AI",
      "circles": "Круги",
      "friends": "Люди"
    },
    "sidebar": {
      "searchPlaceholder": "Поиск",
      "empty": "Пока пусто. Когда появятся чаты — увидишь их здесь."
    },
    "header": {
      "aiTyping": "печатает",
      "typing": "печатает…",
      "aiSubtitle": "AI-друг",
      "members": "{{count}} участников",
      "online": "онлайн"
    },
    "aboutEvent": "Об этом мероприятии",
    "liveSession": "Live-сессия",
    "byMaster": "Ведущий: {{name}}",
    "defaultDescription": "Присоединяйтесь к {{name}} на живую практику...",
    "reconnecting": "Переподключение...",
    "disconnected": "Чат отключён",
    "firstMessage": "Будьте первым — поделитесь мыслями...",
    "sayHello": "Поприветствуйте сообщество",
    "host": "ВЕДУЩИЙ",
    "offering": "СДЕЛАТЬ ПОДАРОК",
    "thankYou": "Спасибо за подарок ${{amount}} 🙏",
    "customAmount": "Своя сумма",
    "placeholder": "Напишите в чат практики…",
    "archiveNotice": "Live-сессия отменена. Чат закрыт.",
    "endedNotice": "Live-сессия завершена. Сообщения из чата сохранены, а разговор продолжается в обсуждении.",
    "replyInDiscussion": "Ответить в обсуждении",
    "continueInDiscussion": "Продолжить в обсуждении",
    "openMasterProfile": "Открыть профиль мастера",
    "time": {
      "now": "только что",
      "minutesAgo": "{{count}} мин назад"
    }
  },
  "profile": "ПРОФИЛЬ",
  "contact": {
    "title": "МЫ НА СВЯЗИ",
    "subtitle": "Мы рады общению и вашей обратной связи. Пишите нам!",
    "email": "Почта",
    "instagram": "Instagram",
    "youtube": "YouTube",
    "teamTitle": "Всем Агапе!",
    "teamText": "Привет! Мы - распределенная команда платформы Agapella, работаем из разных стран мира, в разных часовых поясах, вне географии. Если у вас есть вопросы, сложности в использовании платформы, вы заметили ошибку или какое-либо нарушение правил/кодекса этики платформы со стороны мастера или других пользователей — пожалуйста, напишите нам об этом! Если ваш опыт взаимодействия с платформой, мастерами или сообществами оставил теплые впечатления, добавил ощущения опоры и любви - пожалуйста, поделитесь своими эмоциями и наблюдениями. Совместно с вами и благодаря вашей обратной связи мы развиваем платформу."
  },
  "kula": {
    "globalCommunity": "ГЛОБАЛЬНОЕ СООБЩЕСТВО",
    "circleTitle": "Сообщество",
    "circleSub": "Находите практиков. Присоединяйтесь к кругам. Проходите этот путь вместе.",
    "searchCircles": "Поиск кругов...",
    "circlesSection": "Круги сообщества",
    "peopleSection": "Люди",
    "open": "ОТКРЫТЬ",
    "join": "ВСТУПИТЬ",
    "members": "УЧАСТНИКОВ",
    "allCategories": "Все",
    "create": "Создать",
    "noCircles": "Круги не найдены. Попробуйте другую категорию или поиск.",
    "noCirclesFound": "Ничего не найдено",
    "noMembersFound": "Никого не найдено",
    "heroPhase1Title": "Создай свое окружение.",
    "heroPhase1Scroll": "ПОГРУЗИТЬСЯ",
    "heroPhase2Title": "Найди своих людей",
    "heroPhase2Sub": "Присоединяйся к кругам по интересам и философии. Практикуй и развивайся вместе с теми, кто разделяет твои ценности.",
    "categories": {
      "meditation": "Медитация",
      "psychology": "Психология",
      "philosophy": "Философия",
      "denominations": "Конфессии",
      "body_practices": "Телесные практики",
      "spiritual_practices": "Духовные практики",
      "morning_evening": "Утренние и вечерние",
      "leadership": "Лидерство",
      "motivation": "Мотивация"
    }
  },
  "room": {
    "share": {
      "subject": "Присоединяйтесь к Live-сессии «{{title}}» на Agapella",
      "message": "Присоединяйтесь к Live-сессии «{{title}}» на Agapella\n{{url}}",
      "untitled": "Live-сессия",
      "toFeed": "В свою ленту",
      "toFeedHint": "Анонс этой Live-сессии появится в вашей ленте",
      "toFeedRoomHint": "Эта Live-сессия появится в вашей ленте",
      "toFeedPrivate": "Закрытую Live-сессию нельзя репостнуть в ленту",
      "toFeedCancelled": "Отменённую Live-сессию нельзя репостнуть в ленту",
      "toFeedLookupFailed": "Не удалось проверить, есть ли анонс в ленте. Закройте меню и откройте его снова",
      "practiceToFeed": "Поделиться практикой в своей ленте",
      "practiceToFeedHint": "Практика из библиотеки: «{{title}}»",
      "inApp": "В Agapella"
    },
    "reflection": {
      "banner": "Рефлексия · ещё {{time}}"
    },
    "completed": {
      "banner": "Практика завершена · Live-сессия продолжается"
    },
    "countdown": {
      "banner_one": "Начинаем через {{count}} секунду — подготовьте пространство",
      "banner_few": "Начинаем через {{count}} секунды — подготовьте пространство",
      "banner_many": "Начинаем через {{count}} секунд — подготовьте пространство"
    },
    "tile": {
      "cameraOff": "Камера выключена",
      "videoOnStage": "Видео на сцене",
      "nowPlaying": "Сейчас играет",
      "videoPractice": "Видеопрактика",
      "host": "хост",
      "micLive": "Микрофон включён: {{name}}",
      "micMuted": "Микрофон выключен: {{name}}",
      "mutedByHost": "Заглушён ведущим: {{name}}",
      "handRaised": "Поднял(а) руку: {{name}}"
    },
    "stage": {
      "moreAhead": "+{{count}} · листайте"
    },
    "meta": {
      "by": "от {{name}}",
      "rec": "ЗАПИСЬ",
      "raised": "Подняли руку: {{count}}"
    },
    "roster": {
      "cohost": "Ведущий"
    },
    "participant": {
      "joined": "Присоединился в {{time}}",
      "handRaised": "Рука поднята",
      "close": "Закрыть",
      "roleHost": "Ведущий",
      "roleParticipant": "Участник",
      "micOff": "Микрофон выключен",
      "micOn": "Микрофон включён",
      "videoOn": "Камера включена",
      "audioOnly": "Только аудио"
    },
    "archive": {
      "chatTitle": "Чат",
      "readOnly": "только чтение"
    },
    "panel": {
      "chat": "Чат",
      "participants": "Участники · {{count}}"
    },
    "ended": {
      "banner": "Сессия завершена"
    },
    "silent": {
      "banner": "Тихая практика — ведущий не разрешил включать микрофон и камеру",
      "micDisabled": "Микрофон выключен: идёт тихая практика",
      "camDisabled": "Камера выключена: идёт тихая практика",
      "camBlockedByHost": "Ведущий запретил включать камеру",
      "micBlockedByHost": "Ведущий запретил включать микрофон",
      "camBlockedForYou": "Ведущий выключил вашу камеру"
    },
    "locked": {
      "micStageFull": "Сейчас все места для выступления заняты",
      "camStageFull": "Сейчас все места для выступления заняты",
      "micUnavailable": "Микрофон сейчас недоступен",
      "camUnavailable": "Камера сейчас недоступна"
    },
    "seat": {
      "devicesNotAllowed": "Ведущий не разрешил включать микрофон и камеру",
      "stageFull": "Сейчас все места для выступления заняты. Попробуйте включиться, когда освободится место",
      "unavailable": "Сейчас включиться не получилось. Попробуйте ещё раз чуть позже",
      "network": "Не получилось включиться: нет связи с сервером. Попробуйте ещё раз"
    },
    "floorGranted": {
      "micHint": "Ведущий дал вам слово. Включите микрофон, чтобы вас услышали"
    },
    "spectator": {
      "watchingAsGuest": "Вы смотрите как гость",
      "joinedAs": "Вы вошли как {{name}}",
      "signIn": "Войти",
      "signInToParticipate": "Войти, чтобы участвовать",
      "signInToSpeakChat": "Войдите, чтобы говорить и писать",
      "signInToChat": "Войдите, чтобы писать в чат",
      "signInToRaiseHand": "Войдите, чтобы поднять руку",
      "publishDenied": "Слово выдано, но микрофон пока не открылся. Обновите страницу или попросите ведущего выдать слово ещё раз",
      "viewersWithoutAccount": "Смотрят без аккаунта: {{count}}",
      "moreViewers": "и ещё {{count}} — присоединились раньше вас",
      "sectionTitle": "СЛУШАТЕЛИ",
      "roleLabel": "Слушатель"
    },
    "chat": {
      "placeholder": "Написать сообщение…",
      "connecting": "Чат подключается…",
      "freeze": "Выключить чат",
      "unfreeze": "Включить чат",
      "frozenPlaceholder": "Ведущий выключил чат",
      "mutedPlaceholder": "Ведущий ограничил вам отправку в чат",
      "mutedUntilPlaceholder": "Ведущий ограничил вам отправку в чат до {{time}}",
      "emoji": "Эмодзи",
      "pinnedTitle": "Закреплённое сообщение",
      "unpin": "Открепить",
      "pinFailed": "Не получилось изменить закреплённое сообщение. Попробуйте ещё раз.",
      "deleteConfirmTitle": "Удалить сообщение?",
      "deleteConfirmBody": "Сообщение исчезнет у всех участников Live-сессии. Отменить это нельзя.",
      "deleteConfirm": "Удалить",
      "deleteFailed": "Не получилось удалить сообщение. Попробуйте ещё раз.",
      "attach": {
        "attach": "Прикрепить файл",
        "uploading": "Загружается…",
        "retry": "Ещё раз",
        "remove": "Убрать {{name}}",
        "lessThanMb": "меньше 1 МБ",
        "mb": "{{n}} МБ",
        "defaultName": "файл",
        "defaultImage": "Картинка",
        "defaultFile": "Документ",
        "andMore": "{{list}} и другие",
        "unsupported": "Такой файл отправить не получится. Подойдут картинки ({{images}}) и документы ({{docs}}).",
        "imageTooLarge": "Картинка — до {{limit}}, а эта весит {{size}}. Выберите файл поменьше или сожмите этот.",
        "fileTooLarge": "Документ — до {{limit}}, а этот весит {{size}}. Выберите файл поменьше.",
        "tooMany": "В одно сообщение помещается не больше {{max}} файлов. Отправьте эти и продолжите следующим.",
        "uploadFailed": "Файл не загрузился. Попробуйте ещё раз.",
        "sendFailed": "Сообщение не ушло. Попробуйте отправить ещё раз.",
        "refusedForbidden": "Прикладывать файлы здесь сейчас нельзя.",
        "refusedInvalid": "Этот файл уже отправлен или устарел. Уберите его и приложите заново.",
        "refusedFrozen": "Ведущий выключил чат — сообщение не отправлено.",
        "refusedMuted": "Ведущий на время ограничил вам отправку в чат — сообщение не отправлено.",
        "unavailable": "{{name}} — больше недоступен",
        "openImage": "Открыть картинку: {{name}}",
        "downloadFile": "Скачать документ: {{name}}",
        "kb": "{{n}} КБ",
        "progress": "{{loaded}} из {{total}}",
        "statusUploading": "Загружается {{count}} из {{total}}",
        "statusQueued": "сообщение уйдёт, когда всё загрузится",
        "queueFailed": "Не всё загрузилось — повторите или уберите файл с ошибкой",
        "queueRejected": "Сначала уберите файл, который не принят, — тогда сообщение уйдёт.",
        "failedShort": "Не загрузился",
        "retryShort": "Повторить",
        "downloadAll": "Скачать все · {{size}}",
        "unavailableShort": "Файл больше недоступен",
        "serverUnsupported": "Такой формат файла не поддерживается.",
        "serverTooLarge": "Файл слишком большой.",
        "replaceHint": "Уберите его и выберите другой файл.",
        "failureLine": "{{name}} — {{reason}}",
        "failedIcon": "Файл не принят: {{reason}}"
      }
    },
    "system": {
      "welcome": "Добро пожаловать в Live-сессию",
      "guestWelcome": "Привет, рада, что ты здесь, в Agapella. Ты смотришь Live-сессию как гость — войди или зарегистрируйся, чтобы писать в чат и поднимать руку. Она при этом не прервётся.",
      "practiceBegins": "🙏 Практика начинается",
      "sessionBegins": "🙏 Live-сессия начинается",
      "practiceComplete": "🧘 Практика завершена. Время для рефлексии...",
      "practiceCompleteStay": "🧘 Практика завершена. Live-сессия продолжается — можно пообщаться или выбрать другую практику.",
      "sessionComplete": "✨ Сессия завершена. Спасибо, что были с нами.",
      "plannedTimeElapsed": "⏳ Плановое время Live-сессии истекло. Она продолжается — можно завершить вручную или общаться дальше.",
      "chatConnecting": "Чат подключается — попробуйте через секунду.",
      "chatSendFailed": "Сообщение не отправилось — связь прервалась. Текст вернули в поле ввода.",
      "chatRateLimited": "Сообщение не отправилось — слишком часто. Подождите пару секунд и отправьте ещё раз.",
      "chatMuted": "Ведущий на время ограничил вам отправку в чат. Сообщение не ушло, текст остался в поле ввода.",
      "nowPlaying": "🎵 Сейчас играет: {{title}}",
      "spectating": "Вы смотрите как {{name}}",
      "handRaiseFailed": "Не удалось поднять руку — соединение прервано. Попробуйте ещё раз.",
      "handLowerFailed": "Не удалось опустить руку — соединение прервано. Попробуйте ещё раз."
    },
    "leave": {
      "titleHost": "Завершить практику",
      "titleGuest": "Покинуть Live-сессию",
      "bodyHost": "Завершить практику и закрыть Live-сессию для всех? Действие нельзя отменить.",
      "bodyGuest": "Покинуть Live-сессию? Практика продолжится — другие участники остаются. Вы сможете вернуться по ссылке.",
      "stay": "Остаться",
      "end": "Завершить",
      "leave": "Покинуть",
      "navGuard": "Вы уходите со страницы во время практики. Live-сессия продолжится — гости останутся в ней. Уйти?",
      "navGuardWaiting": "Live-сессия ещё не началась — вы уходите из зала ожидания. Зал останется открытым, гости дождутся начала. Уйти?",
      "handover": {
        "title": "Вы выходите из Live-сессии",
        "body": "Live-сессия продолжится, если передать управление кому-то из участников. Либо её можно завершить для всех.",
        "bodyEmpty": "Передавать управление некому — кроме вас здесь никого нет. Можно остаться или завершить Live-сессию для всех.",
        "handOver": "Передать управление и выйти",
        "endForAll": "Завершить Live-сессию для всех",
        "stay": "Остаться",
        "pickTitle": "Кому передать управление",
        "pickBody": "Выберите, кто продолжит вести практику. Человек получит предложение стать ведущим, и вы выйдете, когда он его примет. Вы останетесь автором: анонс и записи никуда не денутся.",
        "confirm": "Предложить и выйти",
        "handingOver": "Отправляем…",
        "pickBodyHost": "Управление уже у этого ведущего — приглашение не нужно. Вы выйдете сразу, Live-сессия продолжится. Вы останетесь автором: анонс и записи никуда не денутся.",
        "confirmHost": "Передать и выйти",
        "leavingWithHost": "Выходим…",
        "back": "Назад",
        "someone": "Участник",
        "errorGone": "Этот участник уже вышел. Выберите другого.",
        "errorNotHere": "Этого участника здесь нет. Обновите список и выберите другого.",
        "errorFailed": "Не удалось передать управление. Вы остаётесь ведущим — попробуйте ещё раз.",
        "bodyNotAllowed": "Управление этой Live-сессией передать нельзя: другие ведущие есть только в сессиях мастера. Можно остаться или завершить её для всех.",
        "errorNotAllowed": "Управление этой Live-сессией передать нельзя: другие ведущие есть только в сессиях мастера. Можно остаться или завершить её для всех.",
        "bodyWithHosts": "Другие ведущие остаются в Live-сессии — она продолжится без вас. Либо её можно завершить для всех.",
        "leaveOnly": "Выйти — Live-сессию продолжат ведущие",
        "waitingTitle": "Ждём ответа",
        "waiting": "{{name}} получил предложение стать ведущим. Вы выйдете, как только он его примет.",
        "cancelWait": "Отменить и остаться",
        "errorDeclined": "{{name}} отказался. Выберите другого или завершите Live-сессию.",
        "errorExpired": "Предложение для {{name}} больше не действует. Выберите ещё раз."
      },
      "failedTitle": "Не получилось выйти",
      "failedBody": "Связь с сервером прервалась, и выход не сохранился. Вы по-прежнему в Live-сессии — попробуйте выйти ещё раз."
    },
    "status": {
      "connecting": "Подключаемся к Live-сессии…",
      "rateLimited": "Слишком много запросов — пробуем ещё раз…",
      "unavailable": "Live-сессия недоступна",
      "notFound": "Live-сессия не найдена или завершена",
      "removed": "Вас удалили из Live-сессии",
      "goHome": "На главную",
      "linkCopied": "Ссылка на Live-сессию скопирована",
      "linkTitle": "Ссылка на Live-сессию",
      "inviteTitle": "Ссылка-приглашение"
    },
    "actions": {
      "end": "ЗАВЕРШИТЬ",
      "leave": "УЙТИ",
      "stepOut": "ВЫЙТИ",
      "mediaError": "Не удалось сменить медиа",
      "mediaAudioLocked": "Фоновая музыка недоступна в этой Live-сессии. Практику из библиотеки можно выбрать на вкладке «Видео».",
      "mediaAudioNotAllowed": "Фоновая музыка недоступна в этой Live-сессии.",
      "mediaNoRights": "У вас нет прав менять медиа в этой Live-сессии.",
      "mediaPracticeUnavailable": "Эта практика недоступна для показа в Live-сессии.",
      "error": "Ошибка"
    },
    "kicked": {
      "title": "Удалено",
      "body": "Хост удалил вас из Live-сессии."
    },
    "defaultTitle": "Live-сессия",
    "createFailed": "Не удалось создать Live-сессию",
    "tryAgain": "Попробуйте ещё раз.",
    "sessionMoved": {
      "title": "Сессия перемещена",
      "body": "Вы зашли в эту Live-сессию с другого устройства. Сессия перемещена.",
      "close": "Закрыть",
      "rejoin": "Войти здесь"
    },
    "kickParticipant": {
      "title": "Удалить участника",
      "message": "Удалить {{name}} из Live-сессии?",
      "confirm": "Удалить",
      "cancel": "Отмена",
      "button": "Удалить"
    },
    "returnHint": {
      "titleScheduled": "Live-сессия запланирована",
      "bodyScheduled": "Вы можете выйти на платформу и вернуться в эту Live-сессию позже из блока «Ближайшее событие» в своём профиле.",
      "titleReady": "Live-сессия готова",
      "bodyReady": "Вы можете выйти и вернуться к ней из своего профиля до начала Live-сессии.",
      "dismiss": "Понятно",
      "close": "Закрыть"
    },
    "allowParticipantCamera": "Разрешить камеру",
    "webRtcUnsupported": {
      "text": "Похоже, этот браузер не поддерживает звук и видео в Live-сессии. Откройте ссылку в Safari или Chrome, а если на iPhone включён режим блокировки — отключите его для этого сайта."
    },
    "poorLink": {
      "text": "Связь сейчас неровная, поэтому звук может запаздывать. Если включён VPN, попробуйте без него — обычно так звучит чище.",
      "dismiss": "Скрыть"
    },
    "screenAwake": {
      "textIos": "Экран может погаснуть во время Live-сессии. Увеличьте время автоблокировки: Настройки → Экран и яркость → Автоблокировка.",
      "textIosTap": "Чтобы экран не погас во время Live-сессии, коснитесь его.",
      "textAndroid": "Экран может погаснуть во время Live-сессии. Увеличьте время отключения экрана: Настройки → Экран → Время отключения экрана.",
      "dismiss": "Скрыть"
    },
    "hosts": {
      "inviteTitle": "Стать ведущим?",
      "inviteBody": "{{name}} предлагает вам вести эту Live-сессию. У всех ведущих одинаковые инструменты: практика, фон, участники, чат, экран, запись и завершение.",
      "accept": "Принять",
      "decline": "Отказаться",
      "accepting": "Принимаем…",
      "declining": "Отказываемся…",
      "becameHost": "{{name}} теперь ведущий",
      "noLongerHost": "{{name}} больше не ведущий",
      "youAreHost": "Вы стали ведущим",
      "youAreNoLongerHost": "Вы больше не ведущий",
      "invited": "{{name}} получил предложение стать ведущим",
      "declined": "{{name}} отказался быть ведущим",
      "someone": "Участник",
      "errors": {
        "registration_required": "Ведущим может стать только участник с аккаунтом. Гостю нужно войти или зарегистрироваться.",
        "already_host": "Этот участник уже ведущий.",
        "not_present": "Участника уже нет в Live-сессии.",
        "not_pending": "Предложение больше не действует.",
        "stage_full": "На сцене нет свободных мест — сначала заберите слово у кого-нибудь.",
        "session_ended": "Live-сессия уже завершена.",
        "not_allowed": "В этой Live-сессии нельзя назначать ведущих — это доступно в сессиях мастера.",
        "failed": "Не получилось. Попробуйте ещё раз."
      }
    }
  },
  "security": {
    "title": "Безопасность входа",
    "subtitle": "Подключите passkey, чтобы входить без пароля — отпечатком, лицом или ключом устройства.",
    "addPasskey": "Подключить passkey",
    "connectedDevices": "ПОДКЛЮЧЁННЫЕ УСТРОЙСТВА",
    "empty": "Пока нет ни одного passkey. Подключите первый — и пароль больше не понадобится.",
    "unsupportedBrowser": "Этот браузер не поддерживает passkey. Откройте Agapella в Chrome, Safari или Firefox последней версии.",
    "unsupportedNative": "Passkey пока работает только в веб-версии. Откройте agapella.io в браузере и подключите там.",
    "unavailableOnServer": "Passkey пока не подключён на этом сервере. Скоро завезём — заходите чуть позже.",
    "loading": "Загрузка…",
    "device": "Устройство",
    "added": "добавлен ",
    "lastUsed": "последний вход: ",
    "password": {
      "sectionTitle": "ПАРОЛЬ",
      "setTitle": "Задать пароль",
      "setSubtitle": "Сейчас вы входите через Google или Apple. Задайте пароль, чтобы можно было входить и по email.",
      "changeTitle": "Изменить пароль",
      "changeSubtitle": "Пришлём на {{email}} ссылку, по которой вы зададите новый пароль.",
      "sendButton": "Прислать ссылку",
      "sending": "Отправляем…",
      "sentTitle": "Загляните в почту",
      "sentBody": "Отправили ссылку на {{email}}. Откройте её и задайте пароль — она будет жить час.",
      "error": "Не получилось отправить ссылку. Попробуйте чуть позже."
    },
    "mcp": {
      "sectionTitle": "Доступ для ИИ-клиентов",
      "title": "Мои сессии в Claude и других ИИ-клиентах",
      "subtitle": "Ключ даёт ИИ-клиенту доступ к твоим сессиям: списку, транскриптам записей и чату — ровно к тому, что ты видишь здесь. Только чтение. Ключ можно отозвать в любой момент.",
      "mint": "Выпустить ключ",
      "minting": "Выпускаем…",
      "empty": "Ключей пока нет.",
      "keyDefaultLabel": "Ключ",
      "created": "Выпущен ",
      "lastUsed": "использован ",
      "never": "ни разу",
      "revoked": "отозван",
      "show": "Показать",
      "hide": "Скрыть",
      "copy": "Скопировать",
      "copied": "Скопировано",
      "revoke": "Отозвать",
      "revokeConfirm": "Отозвать ключ {{key}}? ИИ-клиент с ним перестанет получать доступ в течение минуты.",
      "configTitle": "Подключение",
      "configHint": "Добавь это в настройки MCP-клиента (Claude Code, Claude Desktop):",
      "unavailable": "Выпуск ключей сейчас недоступен на сервере.",
      "error": "Не получилось. Попробуй ещё раз."
    }
  },
  "aboutPlatform": {
    "title": "О платформе Agapella",
    "subtitle": "Agapella — платформа для поддержки ментального здоровья, психологического благополучия, внутреннего роста, живого взаимодействия мастеров и близких по духу участников.",
    "tabs": {
      "participants": "Для участников",
      "masters": "Для мастеров"
    },
    "showMore": "Показать всё",
    "showLess": "Свернуть",
    "missionCta": "Подробнее о миссии платформы",
    "banner": {
      "title": "Agapella — пространство соучастия и совместного действия",
      "text": "Agapella — это «мы»: ученики и мастера разных школ и традиций объединяются вместе, чтобы создать осознанное поддерживающее сообщество."
    },
    "error": "Не удалось загрузить страницу. Попробуйте позже.",
    "retry": "Повторить"
  },
  "referral": {
    "title": "Реферальная программа",
    "lead": "Делитесь ссылкой на Agapella. Когда те, кого вы привели, покупают курсы и программы мастеров, вам возвращается часть суммы — настоящими деньгами.",
    "leadPoints": "Делитесь ссылкой на Agapella с теми, кому она будет близка. За приглашения могут начисляться баллы: они дают скидку внутри Agapella и не обмениваются на деньги.",
    "pointsNote": "Правила начисления баллов появятся здесь, когда будут утверждены. Условия — в Пользовательском соглашении.",
    "yourLink": "Ваша ссылка",
    "copyLink": "Скопировать ссылку",
    "clicks": "Переходы",
    "registrations": "Регистрации",
    "buyers": "Покупатели",
    "earned": "Заработано",
    "available": "Доступно к выплате",
    "paid": "Выплачено",
    "join": "Подключиться к программе",
    "enrolling": "Подключаем",
    "enrollFailed": "Не получилось подключиться. Попробуйте ещё раз.",
    "termsAccept": "Принимаю условия реферальной программы",
    "termsRead": "Прочитать условия",
    "termsHide": "Свернуть условия",
    "termsLoadFailed": "Не получилось загрузить текст. Попробуйте открыть ещё раз.",
    "termsUnavailable": "Условия программы ещё готовятся. Подключиться можно будет, когда они будут опубликованы.",
    "termsReacceptTitle": "Условия реферальной программы",
    "termsReacceptLead": "Чтобы получать выплаты, примите действующую редакцию условий. Начисления по вашей ссылке при этом продолжаются.",
    "termsReacceptCta": "Принять условия",
    "termsReacceptSaving": "Сохраняем…",
    "recentAccruals": "Последние начисления",
    "level1": "Первый уровень",
    "level2": "Второй уровень",
    "statePending": "Станет доступно позже",
    "statePendingUntil": "Станет доступно",
    "stateAvailable": "Доступно к выплате",
    "statePaid": "Выплачено",
    "stateReturned": "Возвращено",
    "stateOnReview": "На проверке",
    "nextPayout": "Ближайшая выплата —",
    "payoutsPaused": "Выплаты пока недоступны. Начисления копятся и никуда не денутся — мы сообщим, когда их можно будет забрать.",
    "payoutDetails": {
      "entry": "Реквизиты для выплат",
      "entryEmpty": "не заполнены",
      "entryFilled": "заполнены",
      "title": "Реквизиты для выплат",
      "lead": "Чтобы получить вознаграждение в рублях, нужны налоговые данные и счёт. Они уходят на сервер в России и хранятся там — этот экран отправляет их напрямую, минуя остальную платформу.",
      "unavailable": "Приём реквизитов пока не включён. Мы сообщим, когда можно будет заполнить.",
      "fieldInn": "ИНН",
      "fieldBank": "Банковские реквизиты",
      "filledPlaceholder": "заполнено — введите заново, чтобы изменить",
      "inn": "ИНН",
      "beneficiaryName": "ФИО владельца счёта",
      "bankAccount": "Номер счёта",
      "bankBic": "БИК банка",
      "bankName": "Название банка",
      "taxStatus": "Налоговый статус",
      "taxStatuses": {
        "individual": "Физлицо",
        "self_employed": "Самозанятый",
        "sole_trader": "ИП"
      },
      "consentText": "Даю согласие на обработку моих персональных данных для проведения выплат и исполнения налоговых обязанностей. Согласие можно отозвать в любой момент.",
      "save": "Сохранить",
      "saving": "Сохраняем…",
      "saved": "Сохранили.",
      "revoke": "Отозвать согласие",
      "erase": "Удалить данные",
      "revokedNote": "Согласие отозвано, данные стёрты. Выплаты в рублях приостановлены.",
      "rightsNote": "Отзыв согласия закрывает выплаты и стирает реквизиты. История начислений остаётся — она нужна для отчётности.",
      "errors": {
        "INVALID_INN": "ИНН не сходится по контрольной сумме. Проверьте цифры.",
        "INVALID_SNILS": "СНИЛС не сходится по контрольной сумме. Проверьте цифры.",
        "INVALID_BIC": "БИК должен быть из девяти цифр.",
        "INVALID_ACCOUNT": "Счёт и БИК не сходятся между собой. Проверьте оба.",
        "INVALID_TAX_STATUS": "Выберите налоговый статус.",
        "CONSENT_REQUIRED": "Без согласия на обработку данных сохранить не получится.",
        "INN_ALREADY_USED": "Этот ИНН уже привязан к другому аккаунту.",
        "TAX_CONTOUR_NOT_CONFIGURED": "Приём реквизитов пока не включён.",
        "UNKNOWN": "Не удалось сохранить. Попробуйте ещё раз."
      }
    }
  },
  "dates": {
    "monthsFull": [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь"
    ],
    "monthsShort": [
      "янв",
      "фев",
      "мар",
      "апр",
      "мая",
      "июн",
      "июл",
      "авг",
      "сен",
      "окт",
      "ноя",
      "дек"
    ],
    "monthsGenitive": [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря"
    ],
    "weekdaysShort": [
      "Вс",
      "Пн",
      "Вт",
      "Ср",
      "Чт",
      "Пт",
      "Сб"
    ],
    "dayMonth": "{{day}} {{month}}",
    "dayMonthShort": "{{day}} {{month}}",
    "today": "Сегодня",
    "tomorrow": "Завтра",
    "yesterday": "Вчера",
    "dayMonthAtTime": "{{date}} в {{time}}"
  },
  "a11y": {
    "openMenu": "Открыть меню",
    "toggleTheme": "Переключить тему",
    "back": "Назад",
    "close": "Закрыть",
    "menu": "Меню"
  },
  "permissions": {
    "galleryTitle": "Нет доступа",
    "galleryBody": "Разрешите доступ к галерее в настройках."
  },
  "postDiscussion": {
    "open": "Обсудить",
    "openA11y": "Открыть обсуждение публикации",
    "create": "Создать обсуждение",
    "createHint": "Связанное обсуждение появится в «Чатах мастера». У поста для подписчиков оно тоже доступно только им."
  },
  "repost": {
    "title": "Репост в свою ленту",
    "placeholder": "Добавьте пару слов от себя (необязательно)",
    "publish": "Опубликовать",
    "done": "Опубликовано в вашей ленте",
    "signIn": "Чтобы репостнуть в свою ленту, войдите в аккаунт.",
    "action": "Репост",
    "actionA11y": "Репостнуть в свою ленту",
    "kindPost": "Публикация",
    "kindAnnouncement": "Анонс",
    "kindEvent": "Событие",
    "kindPractice": "Практика",
    "kindRecording": "Запись",
    "kindRoom": "Live-сессия",
    "unknownAuthor": "Автор",
    "openOriginal": "Открыть оригинал",
    "unavailable": "Оригинал удалён или недоступен",
    "lockedSubscription": "Полностью доступно подписчикам мастера",
    "lockedPurchase": "Материал доступен в программе мастера",
    "subscribeCta": "Подписаться",
    "purchaseCta": "Открыть программу",
    "stateCancelled": "Отменено",
    "stateLive": "Идёт сейчас",
    "stateEnded": "Завершилось",
    "durationMin": "{{n}} мин",
    "errNotAllowed": "Это нельзя репостнуть: закрытое событие, Live-сессия или практика.",
    "errNotFound": "Оригинал не найден или уже недоступен.",
    "errOpen": "Не удалось подготовить репост. Проверьте соединение и попробуйте ещё раз.",
    "errPrivateRoom": "Это приватная Live-сессия, её репост в ленту недоступен.",
    "errCancelledRoom": "Эта встреча отменена, её репост в ленту недоступен."
  },
  "rewardReactions": {
    "locked": "Эта реакция — подарок за заполненный профиль. Заполни его до {{date}}, и она откроется.",
    "rewardOnly": "Эта реакция — подарок за профиль, заполненный в первый месяц.",
    "unlocked": "Профиль заполнен — тебе открылись три фирменные реакции. Они уже в выборе реакций.",
    "lockedA11y": "{{label}} — откроется за заполненный профиль"
  },
  "eventReport": {
    "tell": "Рассказать, как прошло",
    "tellHint": "Отчёт появится в вашей ленте",
    "published": "Отчёт о событии опубликован",
    "openReport": "Открыть отчёт",
    "overline": "Отчёт о событии",
    "placeholder": "Расскажите, как всё прошло",
    "detach": "Не привязывать к событию",
    "loading": "Загружаем событие…",
    "loadFailed": "Не получилось загрузить событие.",
    "retry": "Повторить",
    "postChip": "Отчёт о событии",
    "openEvent": "Открыть событие, о котором этот отчёт",
    "blocked": {
      "deleted": "Это событие удалено — отчёт к нему не привязать. Уберите привязку, и текст уйдёт обычной публикацией.",
      "not_own": "Это событие другого мастера — рассказать можно только о своём.",
      "online": "Отчёт пишется об офлайн-событиях, а это онлайн-встреча.",
      "not_ended": "Событие ещё не закончилось — рассказать о нём можно будет после окончания.",
      "already_reported": "Отчёт об этом событии уже опубликован, второй не нужен."
    }
  }
}
